module.exports = __webpack_public_path__ + "img/rouge2_noir.5911ed2b.webp";